import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgStop = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.364 4.5H4.636a.136.136 0 0 0-.136.136v14.728c0 .075.061.136.136.136h14.728a.136.136 0 0 0 .136-.136V4.636a.136.136 0 0 0-.136-.136M4.636 3h14.728C20.267 3 21 3.733 21 4.636v14.728c0 .903-.733 1.636-1.636 1.636H4.636A1.636 1.636 0 0 1 3 19.364V4.636C3 3.733 3.733 3 4.636 3"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgStop;
